/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { List, message } from 'antd';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import {
  dbModuleFileToTableEntry,
  TableEntry,
} from '~components/atoms/FileTables/FileTable.utils';
import { FileListItem } from '~components/atoms/mobile/FileListItem/FileListItem';
import { useModuleFiles } from '~src/hooks/api-hooks/useModuleFiles';
import { ThemedStyleFn, useStyles } from '~src/hooks/useStyles';
import { downloadModuleFile } from '~src/utils/download';
import { appLog } from '~src/utils/log';

export const ModuleFileList: React.FC = () => {
  const { moduleId } = useParams<{ moduleId: string }>();

  const intl = useIntl();
  const styles = useStyles(styleFn);

  const moduleFiles = useModuleFiles(
    { module: Number(moduleId), withVersions: false },
    { enabled: true }
  );

  const moduleFilesSource = useMemo(
    () => (moduleFiles.data || []).map(dbModuleFileToTableEntry),
    [moduleFiles.data]
  );

  return (
    <div css={styles.container}>
      <List<TableEntry>
        dataSource={[...moduleFilesSource]}
        css={{ widt: '100%' }}
        loading={moduleFiles.isLoading}
        renderItem={(item) => (
          <FileListItem
            item={item}
            onClick={() => {
              item.dbModuleFile &&
                downloadModuleFile(item.dbModuleFile, () =>
                  message.info(intl.formatMessage({ id: 'download-starting' }))
                ).catch((err) => {
                  appLog('downloadFile -> err', err);
                  message.error(
                    intl.formatMessage({ id: 'file-download-failed' })
                  );
                });
            }}
          />
        )}
      />
    </div>
  );
};

const styleFn: ThemedStyleFn = (theme) => ({
  icons: {
    color: theme.colors.secondary,
    fontSize: '20px',
    margin: '0 2px',
  },
  small: {
    fontSize: '16px',
  },
});
